import {BuildGameConfigurations} from '@colonist/game-base-types'
import {UIAdController} from '../../../shared/scripts/ui_ad/UIAdController'
import {UIGameManager} from '../../../shared/scripts/ui_game/UIGameManager'
import {UIMGameToolTipController} from './ui_game_tooltip/UIMGameToolTipController'
import {UIMGameBankController} from './UIMGameBankController'
import {UIMGameCanvasController} from './UIMGameCanvasController'
import {UIMGameTimerController} from './UIMGameTimerController'
import {UIMGameActionsController} from './ui_game_action/UIMGameActionsController'
import {UIMGameCardController} from './ui_game_card/UIMGameCardController'
import {UIMGameMapController} from './ui_game_map/UIMGameMapController'
import {UIMGamePlayersController} from './ui_game_players/UIMGamePlayersController'
import {UIMGameTradeCreationController} from './ui_game_trade/UIMGameTradeCreationController'
import {UIGameTurnSoundController} from '../../../shared/scripts/ui_game/UIGameTurnSoundController'
import {UIMGameAchievementController} from './ui_game_achievement/UIMGameAchievementController'
import {UIMGameBaseDiceController} from './ui_game_dice/UIMGameBaseDiceController'
import {UIMGamePopupController} from './ui_game_popup/UIMGamePopupController'
import {UIMGameBarbarianInvasion} from './ui_game_cities_and_knights/UIMGameBarbarianInvasion'
import {UIMGameCityImprovement} from './ui_game_cities_and_knights/UIMGameCityImprovement'
import {UIMGameKnightController} from './ui_game_cities_and_knights/UIMGameKnightController'
import {UIMGameEventDiceController} from './ui_game_cities_and_knights/ui_game_cities_and_knights_dice/UIMGameEventDiceController'
import {UIGameFogTileController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameFogTileController'
import {UIGameGoldTileController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameGoldTileController'
import {UIMGameInventorHighlightDiceController} from './ui_game_map/UIMGameInventorHighlightDiceController'
import {UIGameMapChitController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameMapChitController'
import {UIMGameMapCityWallController} from './ui_game_map/UIMGameMapCityWallController'
import {UIGameMapPirateController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameMapPirateController'
import {UIMGameMapShipController} from './ui_game_map/UIMGameMapShipController'
import {UIMGamePlayerInformationLargestArmyController} from './ui_game_players/UIMGamePlayerInformationLargestArmyController'
import {UIMGamePlayerInformationLongestRoadController} from './ui_game_players/UIMGamePlayerInformationLongestRoadController'
import {UIMGamePlayerInformationProgressCardController} from './ui_game_players/UIMGamePlayerInformationProgressCardController'
import {UIMGameSpecialBuildPhaseButtonController} from './ui_game_special_build_phase/UIMGameSpecialBuildPhaseButtonController'
import {UIMGameFeedController} from './ui_game_feed/UIMGameFeedController'
import {UIGameTradeOffersController} from '../../../shared/scripts/trade/ui_trade_offers/UIGameTradeOffersController'
import {UIMGameAnimationController} from './ui_game_animation/UIMGameAnimationController'
import {UIMGameStateController} from './UIMGameStateController'
import {UIMGameLayout} from './UIMGameLayout'
import {UIGameController} from '../../../shared/scripts/ui_game/UIGameController'
import {GameState, NestedReadonly} from '@colonist/game-states'
import {UIGameMapRobberController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameMapRobberController'
import {UIGameMerchantController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameMapMerchantController'
import {UIReplayController} from '../../../shared/scripts/ui_replay/UIReplayController'
import {UIMReplayView} from './UIMReplayView'
import {UIGameActionSuggestionController} from '../../../shared/scripts/ui_game/ui_game_actions/UIGameActionSuggestionController'
import {UIGamePauseController} from '../../../shared/scripts/ui_game/UIGamePauseController'

export class UIMGameManager extends UIGameManager {
    animationController: UIMGameAnimationController

    constructor(adController: UIAdController) {
        super(adController)

        const body = document.getElementsByTagName('body')[0]
        body.classList.add('m-new-game')

        this.canvasController = new UIMGameCanvasController(this)
        this.toolTipController = new UIMGameToolTipController(this)
    }

    buildGame(configurations: BuildGameConfigurations) {
        this.canvasController.responsiveController.resizeScreen()
        this.gameController = new UIGameController(this, configurations)

        super.buildGame(configurations)

        const {
            tradeState,
            mechanicDevelopmentCardsState,
            mechanicProgressCardsState,
            mechanicSettlementState,
            mechanicCityState,
            mechanicCityWallState,
            mechanicCityImprovementsState,
            mechanicRoadState,
            mechanicLongestRoadState,
            mechanicLargestArmyState,
            mechanicSpecialBuildPhaseState,
            mechanicRobberState,
            mechanicEventDiceState,
        } = configurations.gameState

        this.gameLayout = new UIMGameLayout(this)
        this.animationController = new UIMGameAnimationController(this)
        this.mapController = new UIMGameMapController(this) // Jan 28, 2021. Jeff: Map first so its below containers
        this.bankController = new UIMGameBankController(this, mechanicDevelopmentCardsState, mechanicProgressCardsState)
        this.playersController = new UIMGamePlayersController(this,
            mechanicDevelopmentCardsState,
            mechanicProgressCardsState,
            mechanicSettlementState,
            mechanicCityState,
            mechanicCityWallState,
            mechanicCityImprovementsState,
            mechanicRoadState,
            mechanicLongestRoadState,
            mechanicLargestArmyState,
            mechanicSpecialBuildPhaseState)
        this.actionsController = new UIMGameActionsController(this, mechanicSettlementState, mechanicCityState, mechanicRoadState)
        this.tradeController = new UIMGameTradeCreationController(this)
        this.cardController = new UIMGameCardController(this, mechanicRobberState)
        const isLiveGame = !this.gameController.isReplay
        if(isLiveGame) this.timerController = new UIMGameTimerController(this)
        this.diceController = new UIMGameBaseDiceController(this, mechanicEventDiceState)
        new UIMGameStateController(this)
        new UIGameTradeOffersController(this, tradeState.activeOffers)
        new UIMGameAchievementController(this)
        new UIGameTurnSoundController(this)
        new UIMGamePopupController(this, mechanicProgressCardsState)
        new UIGameActionSuggestionController(this, mechanicDevelopmentCardsState, mechanicProgressCardsState)
        this.pauseController = new UIGamePauseController(this)
        new UIGameGoldTileController(this)

        this.buildOrderDependentControllers(configurations.gameState)
    }

    buildGameFeed() {
        if(this.chatController != undefined) return
        this.chatController = new UIMGameFeedController(this)
    }

    buildReplayView(replayController: UIReplayController): void {
        this.replayView = new UIMReplayView(replayController)
        this.replayView.setPosition()
    }

    private buildOrderDependentControllers(gameState: NestedReadonly<GameState>) {
        this.mapController.createMap()
        this.buildOptionalMechanics(gameState)
        this.actionsController.buildButtonController()
        this.mapController.mapView.sortChildren()
        if(this.originalMapPosition != undefined) {
            this.mapController.mapView.scale.set(this.originalMapPosition.zoom.x, this.originalMapPosition.zoom.y)
            this.mapController.mapView.emit('zoomed', this.mapController.mapView.DEFAULT_ZOOM_EVENT)
            this.mapController.mapView.repositionMap(this.originalMapPosition.location)
        }
    }

    protected buildOptionalMechanics(gameState: NestedReadonly<GameState>) {
        if(gameState.mechanicDevelopmentCardsState) {
            this.actionsController.activateBuyDevelopmentCardButton(gameState.mechanicDevelopmentCardsState)
        }

        if(gameState.mechanicCityWallState) {
            new UIMGameMapCityWallController(this, gameState.mechanicCityWallState)
        }

        if(gameState.mechanicShipState) {
            new UIMGameMapShipController(this, gameState.mechanicShipState, gameState.mechanicPirateState)
        }

        if(gameState.mechanicLongestRoadState) {
            new UIMGamePlayerInformationLongestRoadController(this, gameState.mechanicLongestRoadState)
        }

        if(gameState.mechanicLargestArmyState) {
            new UIMGamePlayerInformationLargestArmyController(this, gameState.mechanicLargestArmyState)
        }

        if(gameState.mechanicRobberState) {
            new UIGameMapRobberController(this, gameState.mechanicRobberState)
        }

        if(gameState.mechanicPirateState) {
            new UIGameMapPirateController(this, gameState.mechanicPirateState)
        }

        if(gameState.mechanicEventDiceState) {
            new UIMGameEventDiceController(this, gameState.mechanicEventDiceState)
        }

        if(gameState.mechanicSpecialBuildPhaseState) {
            new UIMGameSpecialBuildPhaseButtonController(this, gameState.mechanicSpecialBuildPhaseState)
        }

        if(gameState.mechanicIslandExplorationState) {
            new UIGameMapChitController(this)
        }

        if(gameState.mapState.fogTileGroupStates) {
            new UIGameFogTileController(this, gameState.mapState.fogTileGroupStates)
        }

        if(gameState.mechanicKnightState) {
            new UIMGameKnightController(this, gameState.mechanicKnightState, gameState.mechanicRobberState, gameState.mechanicPirateState)
        }

        if(gameState.mechanicMerchantState) {
            new UIGameMerchantController(this, gameState.mechanicMerchantState)
        }

        if(gameState.mechanicBarbarianInvasionState && gameState.mechanicKnightState) {
            new UIMGameBarbarianInvasion(this, gameState.mechanicBarbarianInvasionState, gameState.mechanicKnightState)
        }

        if(gameState.mechanicProgressCardsState) {
            new UIMGamePlayerInformationProgressCardController(this)
            new UIMGameInventorHighlightDiceController(this)
        }

        if(gameState.mechanicCityImprovementsState) {
            new UIMGameCityImprovement(this, gameState.mechanicCityImprovementsState, gameState.mechanicRobberState)
        }

        super.buildOptionalMechanics(gameState)
    }
}
